import type { SeoResolver } from '../types';

/**
 * SEO for a selected radio station. New (the layer had no dedicated SEO before),
 * keyed on the store's selectedRadioStation.
 */
export const radioSeoResolver: SeoResolver = (ctx) => {
  const station = ctx.selections.radioStation;
  if (!station) return null;

  const { siteName, layerName } = ctx;
  const p = station.properties;
  const where = p.city ? ` (${p.city})` : '';

  return {
    title: `${p.name} — Live FM Radio${where} | ${layerName} | ${siteName}`,
    description: `Listen to ${p.name}${p.city ? `, ${p.city}` : ''} live and explore local FM radio stations across Tamil Nadu on ${siteName}.`,
    breadcrumbLabel: p.name
  };
};
